<mat-progress-bar mode="indeterminate" *ngIf="!loaded"></mat-progress-bar>

<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

    <ng-container matColumnDef="DOC_ID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">Doc. ID
      <td mat-cell *matCellDef="let element">{{element.DOC_ID}}</td>
    </ng-container>

    <ng-container matColumnDef="DATA_DOC">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Data doc.</th>
      <td mat-cell *matCellDef="let element">{{element.DATA_DOC | date:'dd/MM/yyyy'}}</td>
    </ng-container>

    <ng-container matColumnDef="RAG_SOC_CF">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
      <td mat-cell *matCellDef="let element">{{element.RAG_SOC_CF }}
        ({{element.COD_CF}})</td>
    </ng-container>

    <ng-container matColumnDef="IMPONIBILE_V1">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Imponibile</th>
      <td mat-cell *matCellDef="let element">{{element.IMPONIBILE_V1 | currency:'EUR'}}</td>
    </ng-container>

    <ng-container matColumnDef="FLAG_EVASO">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Stato</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.FLAG_EVASO === 0" class="badge badge-primary">DA EVADERE</span>
        <span *ngIf="element.FLAG_EVASO === 1" class="badge badge-secondary">IN EVASIONE</span>
        <span *ngIf="element.FLAG_EVASO === 2" class="badge badge-success">EVASO</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="SITUAZIONE_ORDINE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Situazione</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.SITUAZIONE_ORDINE === 0" class="badge badge-success">EVADIBILE</span>
        <span *ngIf="element.SITUAZIONE_ORDINE === 1" class="badge badge-danger">NON EVADIBILE</span>
        <span *ngIf="element.SITUAZIONE_ORDINE === 2" class="badge badge-warning">ANNULLATO</span>
      </td>
    </ng-container>


    <!-- Filter per DOC_ID -->
    <ng-container matColumnDef="DOC_ID-filter">
      <th mat-header-cell *matHeaderCellDef>
        <input type="text" (input)="filterchanged($event, 'DOC_ID')" placeholder="Filtro DOC." class="form-control form-control-sm" />
      </th>
    </ng-container>

    <ng-container matColumnDef="DATA_DOC-filter">
      <th mat-header-cell *matHeaderCellDef>
        <div class="input-group">
          <input
            class="form-control form-control-sm d-none"
            placeholder="Da data"
            name="dpFrom"
            (click)="dFrom.toggle()"
            (change)="filterchanged($event, 'DATA_DOC')"
            ngbDatepicker
            #dFrom="ngbDatepicker"
            [placement]="'bottom-right'"
          /><br>
          <input
            class="form-control form-control-sm d-none"
            placeholder="A data"
            name="dpTo"
            (click)="dTo.toggle()"
            (change)="filterchanged($event, 'DATA_DOC')"
            ngbDatepicker
            #dTo="ngbDatepicker"
            [placement]="'bottom-right'"
          />
        </div>
      </th>
    </ng-container>


     <!-- Filter per RAG_SOC_CF -->
    <ng-container matColumnDef="RAG_SOC_CF-filter">
      <th mat-header-cell *matHeaderCellDef>
        <input type="text" (input)="filterchanged($event, 'RAG_SOC_CF')" placeholder="Filtro Cliente" class="form-control form-control-sm" />
      </th>
    </ng-container> 

    <ng-container matColumnDef="IMPONIBILE_V1-filter">
      <th mat-header-cell *matHeaderCellDef>
      </th>
    </ng-container> 
    <ng-container matColumnDef="FLAG_EVASO-filter">
      <th mat-header-cell *matHeaderCellDef>

          <select (change)="filterchanged($event, 'FLAG_EVASO')" class="form-control form-control-sm">
            <option value="">Tutti</option>
            <option value="0">DA EVADERE</option>
            <option value="1">IN EVASIONE</option>
            <option value="2">EVASO</option>
          </select>

      </th>
    </ng-container> 
    <ng-container matColumnDef="SITUAZIONE_ORDINE-filter">
      <th mat-header-cell *matHeaderCellDef>

          <select (change)="filterchanged($event, 'SITUAZIONE_ORDINE')" class="form-control form-control-sm">
            <option value="">Tutti</option>
            <option value="0">EVADIBILE</option>
            <option value="1">NON EVADIBILE</option>
            <option value="2">ANNULLATO</option>
          </select>

      </th>
    </ng-container> 

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>    

    <!-- Filter Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumnFilters"></tr>

    <!-- Data Rows -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </table>

  <mat-paginator #paginator showFirstLastButtons [length]="totalCount" [pageIndex]="currentPage" [pageSize]="perPage"
    [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
  </mat-paginator>
</div>